import React, {useContext, useEffect, useReducer, useState} from 'react';
import {Button, Form, Header, Icon, Loader, Menu, Segment} from "semantic-ui-react";
import axios from "axios";
import Table from "semantic-ui-react/dist/commonjs/collections/Table";
import Popup from "semantic-ui-react/dist/commonjs/modules/Popup";

import { toast, ToastContainer } from 'react-toastify';
import moment from "moment";
import ContractForm from "./ContractForm";
import {UserRoleContext} from "../../Main";
import SearchTableData from "../Utilities/SearchTableData";
import ReactExport from 'react-data-export';
import PaginationFront from "../Utilities/PaginationFront";


const reducer = (state, action)=> {
    switch (action.type) {
        case 'contracts':
            return {...state, contracts: action.payload};
        case 'contractsData':
            return {...state, contractsData: action.payload};
        case 'currentId':
            return {...state, currentId: action.payload};
        case 'contract':
            return {...state, contract: action.payload};
        case 'openTable':
            return {...state, openTable: action.payload};
        case 'organizer':
            return {...state, organizer: action.payload};
        case 'organizers':
            return {...state, organizers: action.payload};
        case 'currentIdOrganizer':
            return {...state, currentIdOrganizer: action.payload};
        case 'loader':
            return {...state, loader: action.payload};
        case 'data':
            return {...state, data: action.payload};
        case 'results':
            return {...state, results: action.payload};
        case 'postsPerPage':
            return {...state, postsPerPage: action.payload};
        case 'currentPosts':
            return {...state, currentPosts: action.payload};
        default:
            return state;

    }
}

const Contracts = () => {
    const {activeRole} = useContext(UserRoleContext);
    const { ExcelFile } = ReactExport;
    const { ExcelSheet } = ReactExport.ExcelFile;
    const [showAddForm, setShowAddForm] = useState(false);
    const [showEditForm, setShowEditForm] = useState(false);
    const [activePage, setActivePage] = useState(1);
    const [state, dispatch] = useReducer(reducer,{
        contracts: [],
        contractsData: [],
        currentId: null,
        contract: '',
        openTable: false,
        organizer: '',
        organizers: [],
        currentIdOrganizer: null,
        loader: false,
        data:[],
        results:[],
        postsPerPage: 20,
        currentPosts: [],
    });

    const columns = [
        { title: 'Struka', width: { wpx: 200 } },
        { title: 'Zanimanje', width: { wpx: 200 } },
        { title: 'Poslodavac', width: { wpx: 150 } },
        { title: 'Grad', width: { wpx: 150 } },
        { title: 'Telefon', width: { wpx: 150 } },
        { title: 'Broj ugovora', width: { wpx: 150 } },
        { title: 'Datum ugovora', width: { wpx: 250 } },
    ];

    if (activeRole !== "ROLE_ORGANIZER") {
        columns.unshift({ title: 'Organizator', width: { wpx: 250 } });
    }

    const multiDataSet = [
        {
            columns: columns,
            data: state.contractsData,
        }
    ];

    // const multiDataSet = [
    //     {
    //         columns: [
    //             { title: 'Struka', width: { wpx: 200 } },
    //             { title: 'Zanimanje', width: { wpx: 200 } },
    //             { title: 'Poslodavac', width: { wpx: 150 } },
    //             { title: 'Grad', width: { wpx: 150 } },
    //             { title: 'Telefon', width: { wpx: 150 } },
    //             { title: 'Broj ugovora', width: { wpx: 150 } },
    //             { title: 'Datum ugovora', width: { wpx: 250 } },
    //         ],
    //         data: state.contractsData,
    //     }
    // ];

    const indexOfLastPost = activePage * state.postsPerPage;
    const indexOfFirstPost = indexOfLastPost - state.postsPerPage;
    const currentPosts = getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

    let toggleAddForm = () =>{
        setShowAddForm(!showAddForm)
    };

    let toggleEditForm = () =>{
        setShowEditForm(!showEditForm)
    };

    function setCurrentId(value){
        dispatch({type: 'currentId', payload: value});
    }

    function getDataToRender() {
        if (state.results.length !== 0) {
            return state.results;
        }
        return state.data;
    }

    const handlePaginationChange = (e, { activePage }) => {
        setActivePage(activePage);
    };

    function getResults(results) {
        dispatch({type: 'results', payload: results});
        setActivePage(1);
        handlePaginationChange({}, { activePage });
    }

    function setCurrentIdOrganizer(value){
        dispatch({type: 'organizer', payload: value});
    }

    function deleteContract(id){
        setCurrentId(id);
        dispatch({type: 'loader', payload: true});
        axios.delete(`/contract/delete/${id}`,).then(
            (res) => {
                activeRole === "ROLE_ORGANIZER" && getContracts();
                activeRole === "ROLE_ADMIN" && getContractsForAdmin(state.organizer);
                toast('Uspješno ste izbrisali ugovor!');
                dispatch({type: 'loader', payload: false});
                setCurrentId(null);
            }).catch((err) => {
            console.log('err', err)
        });
    }

    useEffect(() => {
        if (activeRole === "ROLE_ORGANIZER") {
            getContracts()
        }
        else if (activeRole === "ROLE_ADMIN" || activeRole === "ROLE_MINISTRY") {
            getOrganizers();
            getContractsAll();
        }
        // activeRole === "ROLE_ORGANIZER" ? getContracts() : getOrganizers();
    },[activeRole]);

    function getOrganizers(){
        dispatch({type: 'loader', payload: true});
        axios.get('/organizer/all',).then(
            (res) => {
                let organizers = res.data.map((el)=>({...el, key: el.id, text:el.name, value: el.id}));
                dispatch({type: 'organizers', payload: organizers});
                dispatch({type: 'loader', payload: false});
            }).catch((err) => {
            console.log('err', err)
        });
    }

    function getContracts(){
        dispatch({type: 'loader', payload: true});
        axios.get('/contract/by-organizer',).then(
            (res) => {
                let contracts = res.data.map(el => ({
                    ...el,
                    occupationProfession:el.occupation.profession.name,
                    occupationNameBosnian:el.occupation.nameBosnian,
                    employerName: el.employer.name,
                    placeName: el.employer.residence.place.name,
                    date: moment(el.contractDate).format('D. M. YYYY.')
                }))
                // let contracts = res.data;
                dispatch({type: 'contracts', payload: contracts});
                dispatch({type: 'data', payload: contracts});
                let contractsData = res.data.map(el => ([
                    { value: el.occupation.profession.name },
                    { value: el.occupation.nameBosnian },
                    { value: el.employer.name },
                    { value: el.employer.residence.place.name},
                    { value: el.employer.phone},
                    { value: el.contractNumber},
                    { value: moment(el.contractDate).format('D. M. YYYY.') },
                ]));
                dispatch({type: 'contractsData', payload: contractsData});
                dispatch({type: 'loader', payload: false});
            }).catch((err) => {
            console.log('err', err)
        });
    }


    function getContractsAll(){
        dispatch({type: 'loader', payload: true});
        axios.get('/contract/all',).then(
            (res) => {
                let contracts = res.data.map(el => ({
                    ...el,
                    occupationProfession:el.occupation.profession.name,
                    occupationNameBosnian:el.occupation.nameBosnian,
                    employerName: el.employer.name,
                    placeName: el.employer.residence.place.name,
                    date: moment(el.contractDate).format('D. M. YYYY.')
                }))
                // let contracts = res.data;
                dispatch({type: 'contracts', payload: contracts});
                dispatch({type: 'data', payload: contracts});
                let contractsData = res.data.map(el => ([
                    { value: el.organizer.name },
                    { value: el.occupation.profession.name },
                    { value: el.occupation.nameBosnian },
                    { value: el.employer.name },
                    { value: el.employer.residence.place.name},
                    { value: el.employer.phone},
                    { value: el.contractNumber},
                    { value: moment(el.contractDate).format('D. M. YYYY.') },
                ]));
                dispatch({type: 'contractsData', payload: contractsData});
                dispatch({type: 'loader', payload: false});
            }).catch((err) => {
            console.log('err', err)
        });
    }

    function handleInputChange(event, { name, value }) {
        dispatch({type: name, payload: value});
        if(name === 'organizer' && value){
            dispatch({type: 'openTable', payload: true});
            getContractsForAdmin(value)
        }
        if(name === 'organizer' && !value){
            dispatch({type: 'openTable', payload: true});
            getContractsAll()
        }
    }

    function getContractsForAdmin(id){
        setCurrentId(id);
        setCurrentIdOrganizer(id);
        dispatch({type: 'loader', payload: true});
        dispatch({type: 'openTable', payload: true});
        axios.get(`/contract/by-organizer-id/${id}`,).then(
            (res) => {
                let contracts = res.data.map(el => ({
                    ...el,
                    occupationProfession:el.occupation.profession.name,
                    occupationNameBosnian:el.occupation.nameBosnian,
                    employerName: el.employer.name,
                    placeName: el.employer.residence.place.name,
                    date: moment(el.contractDate).format('D. M. YYYY.')
                }))
                // let contracts = res.data;
                dispatch({type: 'contracts', payload: contracts});
                dispatch({type: 'data', payload: contracts});
                let contractsData = res.data.map(el => ([
                    { value: el.organizer.name },
                    { value: el.occupation.profession.name },
                    { value: el.occupation.nameBosnian },
                    { value: el.employer.name },
                    { value: el.employer.residence.place.name},
                    { value: el.employer.phone},
                    { value: el.contractNumber},
                    { value: moment(el.contractDate).format('D. M. YYYY.') },
                ]));
                dispatch({type: 'contractsData', payload: contractsData});
                dispatch({type: 'loader', payload: false});
                setCurrentId(null);
            }).catch((err) => {
            console.log('err', err)
        });
    }

    return (
        <div>
            <Segment.Group >

                <Segment className={'customPadding'} clearing color={"teal"}>

                    <Menu  secondary size={"tiny"} compact stackable floated={"right"} fluid>

                        <Menu.Item >
                            <Header as={'h3'} floated={"left"}> Spisak ugovora </Header>
                        </Menu.Item>
                         <Menu.Menu position={'right'}>
                             {(!showEditForm && activeRole !== "ROLE_MINISTRY") &&
                            <Menu.Item>
                                <Button icon labelPosition='left' size="mini" basic color="black" onClick={toggleAddForm}>
                                    <Icon name='add' color={"teal"}/>
                                    Kreiraj ugovor
                                </Button>
                            </Menu.Item>}
                        </Menu.Menu>
                        <Menu.Item>
                            <ExcelFile filename="Spisak ugovora" element={<Button icon labelPosition='left' size="tiny" basic color="black">
                                <Icon name='file excel outline' color={"green"}/>
                                Preuzmi spisak
                            </Button>}>
                                <ExcelSheet dataSet={multiDataSet} name="Ugovori" />
                            </ExcelFile>
                        </Menu.Item>
                        <Menu.Item>
                                <span>
                                    <Button floated={"right"} icon size={"mini"} basic onClick={() => window.history.go(-1)}>
                                        <Icon name='arrow left'/>
                                    </Button>
                                    <Icon/>
                                </span>
                        </Menu.Item>

                    </Menu>

                </Segment>

                {showAddForm &&
                <Segment>
                    <ContractForm add toggleEditForm={toggleAddForm} getContract={getContracts} getContractsForAdmin={getContractsForAdmin} setCurrentIdOrganizer={setCurrentIdOrganizer}/>
                </Segment>}

                {showEditForm &&
                <Segment>
                    <ContractForm edit toggleEditForm={toggleEditForm} getContract={getContracts} contract={state.contract} getContractsForAdmin={getContractsForAdmin} setCurrentIdOrganizer={setCurrentIdOrganizer}/>
                </Segment>}

                {(activeRole === "ROLE_ADMIN" || activeRole === "ROLE_MINISTRY") && <Segment><Form size={'small'}>
                    <Form.Group widths="3">
                        <Form.Field>
                            <label>Organizator</label>
                            <Form.Dropdown
                                placeholder="Odaberite organizatora"
                                value={state.organizer}
                                onChange={handleInputChange}
                                name="organizer"
                                options={state.organizers}
                                search
                                fluid
                                selection
                                clearable
                            />
                        </Form.Field>
                    </Form.Group>
                </Form></Segment>}
                {/*{((activeRole === "ROLE_ADMIN" && state.openTable) || (activeRole === "ROLE_MINISTRY" && state.openTable) || activeRole === "ROLE_ORGANIZER") &&*/}
                <Segment>
                    {state.loader ?
                        <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                        :
                        currentPosts.length ?
                            <Table celled size={'small'}>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan={activeRole !== "ROLE_ORGANIZER" ? 11 : 9} >
                                            <div style={{ paddingLeft: '0px' }}>
                                                <SearchTableData data={state.data} getResults={getResults} filterItem={['date','contractNumber', 'occupationProfession', 'occupationNameBosnian', 'employerName', 'placeName']} />
                                            </div>
                                        </Table.HeaderCell>
                                    </Table.Row>
                                    <Table.Row>

                                        <Table.HeaderCell >R. br.</Table.HeaderCell>
                                        {/*<Table.HeaderCell colSpan={2} >Organizator</Table.HeaderCell>*/}
                                        {activeRole !== "ROLE_ORGANIZER"  &&<Table.HeaderCell colSpan={2} >Organizator</Table.HeaderCell>}
                                        <Table.HeaderCell >Zanimanje</Table.HeaderCell>
                                        <Table.HeaderCell >Poslodavac</Table.HeaderCell>
                                        <Table.HeaderCell >Grad</Table.HeaderCell>
                                        <Table.HeaderCell >Telefon</Table.HeaderCell>
                                        <Table.HeaderCell >Broj ugovora</Table.HeaderCell>
                                        <Table.HeaderCell >Datum ugovora</Table.HeaderCell>
                                        {activeRole !== "ROLE_MINISTRY" &&<Table.HeaderCell width={1} />}
                                    </Table.Row>
                                </Table.Header>

                                <Table.Body>
                                    {
                                        currentPosts.map((el, index) =>
                                        // state.contracts.map((el, index)=>
                                            (<Table.Row key={el.id}>
                                                <Table.Cell>{(index + 1) + ((activePage - 1) * state.postsPerPage)}.</Table.Cell>
                                                {/*<Table.Cell colSpan={2}>{el.organizer.name}</Table.Cell>*/}
                                                {activeRole !== "ROLE_ORGANIZER"  &&<Table.Cell colSpan={2}>{el.organizer.name}</Table.Cell>}
                                                <Table.Cell><strong>{el.occupation.profession.name}</strong> | {el.occupation.nameBosnian}</Table.Cell>
                                                <Table.Cell>{el.employer.name}</Table.Cell>
                                                <Table.Cell>{el.employer.residence.place.municipality && el.employer.residence.place.municipality.canton ? el.employer.residence.place.name + " | " + el.employer.residence.place.municipality.canton.name + " | " + el.employer.residence.place.municipality.name: el.employer.residence.place.municipality && !el.employer.residence.place.municipality.canton ? el.employer.residence.place.name + " | "+ el.employer.residence.place.municipality.name : el.employer.residence.place.name}</Table.Cell>
                                                {/*<Table.Cell>{el.employer.residence.place.municipality && el.employer.residence.place.municipality.canton ? el.employer.residence.place.municipality.canton.name + " | " + el.employer.residence.place.municipality.name + " | " +el.employer.residence.place.name: el.employer.residence.place.municipality && !el.employer.residence.place.municipality.canton ? el.employer.residence.place.municipality.name + " | " +el.employer.residence.place.name: el.employer.residence.place.name}</Table.Cell>*/}
                                                <Table.Cell>{el.employer.phone}</Table.Cell>
                                                <Table.Cell>{el.contractNumber}</Table.Cell>
                                                <Table.Cell>{moment(el.contractDate).format('D. M. YYYY.')}</Table.Cell>
                                                {activeRole !== "ROLE_MINISTRY" && <Table.Cell width={1} verticalAlign="middle" textAlign="center">
                                                    <Popup size={"small"} content='Izmijeni ugovor' trigger={
                                                        <Button icon size={"mini"} basic color={"grey"} onClick={() => {setShowEditForm(true); dispatch({type: 'contract', payload: el})}}>
                                                            <Icon name='pencil' color={"teal"} />
                                                        </Button>} />
                                                    <Popup size={"small"} content='Obriši ugovor' trigger={
                                                        <Button icon size={"mini"} basic color={"grey"} disabled={state.currentId && el.id !== state.currentId } onClick={() => {deleteContract(el.id)}}>
                                                            <Icon name='trash alternate outline' color={"red"} />
                                                        </Button>} />
                                                </Table.Cell>}
                                            </Table.Row>)
                                        )
                                    }


                                </Table.Body>

                                <Table.Footer>
                                    {/*<Table.Row>*/}
                                    {/*    <Table.HeaderCell colSpan='11' textAlign='center'>*/}
                                    {/*        <Menu  pagination>*/}
                                    {/*            <Menu.Item as='a' icon>*/}
                                    {/*                <Icon name='chevron left' />*/}
                                    {/*            </Menu.Item>*/}
                                    {/*            <Menu.Item as='a'>1</Menu.Item>*/}
                                    {/*            <Menu.Item as='a'>2</Menu.Item>*/}
                                    {/*            <Menu.Item as='a'>3</Menu.Item>*/}
                                    {/*            <Menu.Item as='a'>4</Menu.Item>*/}
                                    {/*            <Menu.Item as='a' icon>*/}
                                    {/*                <Icon name='chevron right' />*/}
                                    {/*            </Menu.Item>*/}
                                    {/*        </Menu>*/}
                                    {/*    </Table.HeaderCell>*/}
                                    {/*</Table.Row>*/}
                                </Table.Footer>
                            </Table> : <div>Nema unesenih podataka o ugovorima.</div>}
                    {currentPosts.length >0 && <PaginationFront postsPerPage={state.postsPerPage} totalPosts={getDataToRender().length} paginate={handlePaginationChange} activePage={activePage} />}
                </Segment>
            </Segment.Group>
            <ToastContainer  />
        </div>
    );
};

export default Contracts;
